import React from "react";
import { useTheme } from "@mui/material";
import { Area, Tooltip as RechartsTooltip, XAxis } from 'recharts';
import { AreaChart, ResponsiveContainer } from "recharts";
import { colord } from "colord";

export interface SimpleSparklineProps {
  data?: Array<any>;
  numericData?: number[];

  color?: string;
  areaFillColor?: string;

  onClick?: (index: number) => void;
  setHoveredIndex?: (index?: number | null) => void;
  setHovered?: (hovered: boolean) => void;
}

export default function SimpleSparkline(props: SimpleSparklineProps): JSX.Element {
  const theme = useTheme();

  const {
    data, numericData,
    color, areaFillColor,
    onClick, setHoveredIndex, setHovered,
  } = props;

  let sparklineData: Array<any> | undefined = data;
  if (numericData && numericData.length > 0) {
    sparklineData = numericData.map((value, index) => {
      return {
        value: value,
        index: index
      }
    });
  }

  return (
    <ResponsiveContainer>
      <AreaChart style={{ cursor: "pointer" }}
        data={sparklineData}
        margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
        onClick={(event: any) => {
          if (onClick) {
            onClick(event.activeTooltipIndex);
          }
        }}
        onMouseMove={(event: any) => {
          if (setHoveredIndex) {
            setHoveredIndex(event.activeTooltipIndex);
          }
          if (setHovered) {
            setHovered(true);
          }
        }}
        onMouseLeave={() => {
          if (setHovered) {
            setHovered(false);
          }
          if (setHoveredIndex) {
            setHoveredIndex(undefined);
          }
        }}
      >
        <Area
          type="monotone"
          dataKey="value"
          stroke={color ?? theme.palette.primary.main}
          strokeWidth="2"
          fill={colord(areaFillColor || color || theme.palette.primary.main).alpha(0.6).toRgbString()}
        />
        <RechartsTooltip active={false} />
      </AreaChart>
    </ResponsiveContainer>

  );

}